import { Typography } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';

type Props = {
    open: boolean;
    templateName?: string;
    onCancel: () => void;
    onConfirm: () => void;
};

const DeleteItemFieldTemplateModal = ({ open, templateName, onCancel, onConfirm }: Props) => (
    <ConfirmationModal
        width={500}
        type="error"
        title="Delete template?"
        confirmButtonText="Delete"
        icon={<DeleteOutlined />}
        content={<Typography.Text>"{templateName}" will be deleted.</Typography.Text>}
        open={open}
        onCancel={onCancel}
        onConfirm={onConfirm}
    />
);

export default DeleteItemFieldTemplateModal;
